import { isTokenExpiring } from '../utils/tokenUtils';
import { apiClient } from './apiClient';
import { AuthResponse } from '../models/auth';

export class TokenInterceptor {
  private static isRefreshing = false;
  private static failedQueue: Array<{
    resolve: (value?: any) => void;
    reject: (reason?: any) => void;
  }> = [];

  static async handleUnauthorized(): Promise<boolean> {
    if (this.isRefreshing) {
      return new Promise((resolve, reject) => {
        this.failedQueue.push({ resolve, reject });
      });
    }

    this.isRefreshing = true;

    try {
      const token = localStorage.getItem('auth-token');
      const refreshToken = localStorage.getItem('refresh-token');


      if (!token || !refreshToken) {
        throw new Error('No tokens found');
      }

      const response = await fetch(`${apiClient.getBaseUrl()}/auth/refresh`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          token,
          refreshToken
        })
      });

      if (!response.ok) {
        await response.text();
        throw new Error(`Refresh token failed: ${response.status}`);
      }

      const authResponse: AuthResponse = await response.json();

      if (authResponse.token) {
        localStorage.setItem('auth-token', authResponse.token);
        localStorage.setItem('refresh-token', authResponse.refreshToken);
        apiClient.setAuthToken(authResponse.token);
        
      }
      
      this.failedQueue.forEach(({ resolve }) => {
        resolve(true);
      });
      this.failedQueue = [];
      
      return true;
    } catch (error) {
      
      this.failedQueue.forEach(({ reject }) => {
        reject(error);
      });
      this.failedQueue = [];
      
      localStorage.removeItem('auth-token');
      localStorage.removeItem('refresh-token');
      localStorage.removeItem('current-user');
      window.location.href = '/login';
      
      return false;
    } finally {
      this.isRefreshing = false;
    }
  }

  static isTokenExpired(token: string): boolean {
    if (!token) return true;
    
    return isTokenExpiring(token, 0.17); 
  }

  static getTokenExpirationTime(token: string): Date | null {
    if (!token) return null;
    
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      return new Date(payload.exp * 1000);
    } catch (error) {
      return null;
    }
  }
}
